import { RouterV3Enum } from '@/router/router-names';
import type { RouteConfig } from 'vue-router';
import { TP_ACTIVITY_HOME_PAGE_ID } from './tianqi';

const ACTIVITY_HOME_ROUTE_CONFIG: RouteConfig = {
  name: RouterV3Enum.activityHome,
  path: RouterV3Enum.activityHome,
  component: () => import(/* webpackChunkName: "activity-home" */'./index.vue'),
  meta: {
    title: '',
    pageId: TP_ACTIVITY_HOME_PAGE_ID,
    needLogin: true,
    ubtPageViewCustom: true,
    isShowH5Nav: true,
    isControlCoffeeH5Nav: true,
  },
};

export default ACTIVITY_HOME_ROUTE_CONFIG;
